  <div class="mx-auto w-full max-w-sm lg:w-96">
    <small [ngStyle]="{'display': (!loginErrorMsg) ? 'none' : 'flex'}"
      class="rounded-lg border border-red-400 bg-red-100 px-4 py-3 text-red-700 flex items-center mt-5 mb-5">
      {{loginErrorMsg}}
    </small>
    <div class="">
      <div class="">
        <form autocomplete="off" [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">

          <div class="form-group space-y-1">
            <label for="oldPassword" class="block text-sm font-medium text-gray-700 mb-2">
              Old Password
            </label>
            <div class="mt-1 relative rounded-md shadow-sm">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <!-- Heroicon name: solid/mail-->
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20"
                  fill="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                </svg>
              </div>
              <input placeholder="Password" type="password" formControlName="oldPassword" id="oldPassword"
              [ngClass]="{ 'border border-red-500': form.get('oldPassword').invalid && isSubmitted }"
                class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md bg-white" />
            </div>
            <div *ngIf="form.get('oldPassword').invalid && isSubmitted" class="flex mt-2">
              <svg class="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd" />
              </svg>
              <span class="text-sm text-red-600 ml-1">
                equired.
              </span>
            </div>
          </div>


          <div class="form-group space-y-1">
            <label for="id-login-password" class="block text-sm font-medium text-gray-700 mb-2">
              New Password
            </label>
            <div class="mt-1 relative rounded-md shadow-sm">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <!-- Heroicon name: solid/mail-->
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20"
                  fill="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                </svg>
              </div>
              <input placeholder="Password" type="password" formControlName="newPassword" id="newPassword"
              [ngClass]="{ 'border border-red-500': form.get('newPassword').invalid && isSubmitted }"
                class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md bg-white" />
            </div>
            <div *ngIf="form.get('newPassword').invalid && isSubmitted" class="flex mt-2">
              <svg class="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd" />
              </svg>
              <span class="text-sm text-red-600 ml-1">
                required.
              </span>
            </div>
          </div>


          <div class="form-group space-y-1">
            <label for="confirmNewPassword" class="block text-sm font-medium text-gray-700 mb-2">
              Confirm New Password
            </label>
            <div class="mt-1 relative rounded-md shadow-sm">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <!-- Heroicon name: solid/mail-->
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20"
                  fill="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                </svg>
              </div>
              <input placeholder="Password" type="password" formControlName="confirmNewPassword" id="confirmNewPassword"
              [ngClass]="{ 'border border-red-500': form.get('confirmNewPassword').invalid && isSubmitted }"
                class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md bg-white" />
            </div>
            <div *ngIf="form.get('confirmNewPassword').invalid && isSubmitted" class="flex mt-2">
              <svg class="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd" />
              </svg>
              <span class="text-sm text-red-600 ml-1">
                required.
              </span>
            </div>
          </div>


          <div class="form-group">
            <button type="submit" [disabled]="loading" class="__btn-main w-full ">
              {{ !loading ? 'Submit' : 'Loading...' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
